<template>
  <div
    class="surverys-tab-survey-card  waves-effect card hoverable"
    :ref="dataSurvey.key"
    @click="$_goTo()"
  >
    <div class="card-content">
      <div class="card-image">
        <img :src="dataSurvey.thumbnail" alt="" />
      </div>
      <div class="card-title center">
        {{ dataSurvey.title }}
      </div>
    </div>
    <div class="progress-wrapper">
      <div class="progress-pusher">
        <div class="description center">
          <!-- {{ dataSurvey.description }} -->
          {{ progressBar }}
        </div>
        <!--  -->

        <div class="c-progress-bar-wrapper">
          <div class="c-progress-percent">
            {{ onlyProgressX ? `${onlyProgressX}%` : "Not Yet Started" }}
          </div>
          <div class="c-progress-bar">
            <div
              class="c-progress"
              :style="{ width: `${onlyProgressX}%` }"
            ></div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>
<script>
// const isElementInView = (elChild, elParent) => {
//   const elChildRect = elChild.getBoundingClientRect();
//   const isInView = elChildRect.left >= 0 && elChildRect.right <= elParent.clientWidth;

//   return isInView;
// };

export default {
  name: "surveyCardEnergy",
  props: {
    dataSurvey: {
      type: Object,
      default: () => ({}),
    },
    dataPerformViewCheck: {
      type: Boolean,
      default: false,
    },
    dataCurrentUser: {
      type: Object,
    },
  },
  data() {
    return {
      parentEl: null,
    };
  },
  mounted() {
    this.parentEl = document.getElementById("home-survey-tabs");
    // this.$_isElementInView();
  },
  isInViewPort() {},
  // watch: {
  //   dataPerformViewCheck() {
  //     this.$_isElementInView();
  //   },
  // },

  computed: {
    // energy: {
    //   get() {
    //     return this.energyX && this.energyX !== ""
    //       ? JSON.parse(this.energyX)
    //       : false;
    //   },
    // },
    energy() {
      if (this.dataCurrentUser) {
        const { energy } = this.dataCurrentUser.acf;

        if (energy) return JSON.parse(energy);

        return false;
      }
      return false;
    },
    assessmentProgressX: {
      get() {
        const allArr = [
          { ...this.floodHazard },
          { ...this.windHazard },
          { ...this.waterHazard },
        ];
        const k =
          allArr.map((x) => x.assessment).filter((y) => y && y.content).length *
          (100 / allArr.length).toFixed(0);
        return k > 99 ? 100 : k;
      },
    },
    onlyProgressX() {
      let elec =
        this.energy &&
        this.energy.electricity.annual_total &&
        this.energy.electricity.annual_total !== ""
          ? 50
          : 0;
      let gas =
        this.energy &&
        this.energy.gas.annual_total &&
        this.energy.gas.annual_total !== ""
          ? 50
          : 0;
      return `${elec + gas}`;
    },
    progressBar: {
      get() {
        let elec =
          this.energy &&
          this.energy.electricity.annual_total &&
          this.energy.electricity.annual_total !== ""
            ? 50
            : 0;
        let gas =
          this.energy &&
          this.energy.gas.annual_total &&
          this.energy.gas.annual_total !== ""
            ? 50
            : 0;
        return `${elec + gas}%`;
      },
    },
  },
  methods: {
    $_goTo() {
     this.$router.push({
        name: "surveyReview",
        params: {
          slug: this.dataSurvey.key
        }
      })
    },
  },
};
</script>
<style lang="scss" scoped>
.surverys-tab-survey-card {
  /*   flex-shrink: 0;
  border-radius: 5px;
  width: 200px;
  padding: 1rem;
  margin-right: 25px; */
  /*
  .image-wrapper {
    width: 100%;
    height: 140px;
    img {
      width: 100%;
      height: 100%;
    }
  } */

  /*   .title {
    text-transform: uppercase;
    color: #545454;
    font-size: 18px;
    font-weight: 600;
    text-align: center;
  } */
  &.card {
    height: calc(100% - 1.5rem);
    border-radius: 10px;
    //overflow: hidden;
    .card-image {
      height: 140px;
      @media screen and (min-width: 1024px) {
        height: 140px;
      }
      width: 100%;
      text-align: center;
      img {
        height: 100%;
        width: auto;
        display: inline-block;
      }
    }
    .card-content {
      padding: 16px 16px;
      .card-title {
        font-size: 15.5px;
        line-height: 20px;
        font-weight: 600;
        margin-bottom: 0px;
        cursor: pointer;
        text-transform: uppercase;
        /* 			white-space: nowrap;
				overflow: hidden;
				text-overflow: ellipsis; */
      }
    }
    .action-wrapper {
      height: 20px;
      width: 100%;
      .card-action {
        position: absolute;
        left: 0;
        right: 0;
        bottom: 0;
      }
    }
    // .card-action {
    //   padding: 0px 16px 16px 16px;
    //   border-radius: 0px 0px 5px 5px;
    //   display: flex;
    //   justify-content: space-between;
    //   button {
    //     border: 1px solid rgba(0, 0, 0, 0.1);
    //     display: flex;
    //     justify-content: center;
    //     align-items: center;
    //   }
    // }
  }
  .description {
    font-size: 12px;
  }

  .c-progress-bar-wrapper {
    margin-top: 8px;
    .c-progress-percent {
      font-size: 9px;
      color: #9c9c9c;
    }
    .c-progress-bar {
      position: relative;
      border-radius: 5px;
      width: 100%;
      height: 9px;
      background: #e4e4e4;
      overflow: hidden;
    }
    .c-progress {
      background: #5374f8;
      height: 100%;
    }
  }
}
.progress-wrapper {
  padding: 0 16px 16px;
  height: 64px;
  .progress-pusher {
    position: absolute;
    width: calc(100% - 32px);
    bottom: 30px;
  }
}
</style>
